import script from "./EventPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPopup.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./EventPopup.vue?vue&type=style&index=0&id=3258e6fd&module=event&lang=css"
cssModules["event"] = style0
import "./EventPopup.vue?vue&type=style&index=1&id=3258e6fd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-3258e6fd"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QImg,QBtn,QSpace,QSeparator});qInstall(script, 'directives', {Scroll});
